import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo obtengo acceso al material? ¿Me envían algo a mi casa?',
    a: 'Estamos en la era digital. Funciona así: vas a ingresar tu información de pago a través de Hotmart (plataforma líder en productos digitales). Después de eso, obtendrás acceso instantáneo a todo el paquete. Es un área de miembros digital. Pagas una sola vez y eso es todo. No hay cargos adicionales, cargos ocultos, ni nada por el estilo.'
  }, {
    q: 'No tengo formación teológica. ¿Esto funcionará para mí?',
    a: '¡Absolutamente! De hecho, este material fue creado PRECISAMENTE pensando en personas como tú. No necesitas tener un título en teología ni años de estudio previo. El lenguaje es claro, accesible y sin tecnicismos. Si sabes leer, puedes entender este material.'
  }, {
    q: '¿Hay algún cargo mensual?',
    a: 'NO. Si aceptas esta oferta ahora mismo, es un pago único de $14.99 por acceso de por vida a todo el material.'
  }, {
    q: '¿Por qué un precio tan bajo? ¿Cuál es la trampa?',
    a: 'No hay trampa. Estamos en una oferta limitada de lanzamiento y queremos recompensar a las personas que toman acción rápida. Es un producto digital, lo que nos permite ofrecer este precio increíble. Pero esta oferta NO durará para siempre. El precio subirá.'
  }, {
    q: 'Soy predicador. ¿Puedo usar este material para preparar mis sermones?',
    a: '¡Por supuesto! De hecho, ese es uno de los usos principales. Muchos pastores y predicadores usan nuestras explicaciones versículo por versículo como base para preparar sermones profundos y estudios bíblicos. Los 7 bonos de predicación están diseñados específicamente para potenciar tu ministerio en el púlpito.'
  }, {
    q: '¿Y si solo me interesan algunas epístolas, no todas?',
    a: 'No tiene sentido comprar una sola epístola cuando te estoy ofreciendo la colección COMPLETA de 13 cartas + 7 bonos por solo $14.99. Incluso si solo planeas estudiar Romanos y Efesios, esta es una ganga de cualquier manera que la mires.'
  }, {
    q: 'Realmente quiero esto, pero quiero asegurarme de que es seguro. ¿Cómo funciona la garantía?',
    a: 'Usamos Hotmart, la plataforma de productos digitales líder en Latinoamérica. Cuando realizas tu orden, te conectas a través de un servidor seguro. Y la garantía de devolución es nuestra promesa personal. Si no te gusta por cualquier razón, solo escríbenos y te devolvemos el 100% de tu dinero. Sin preguntas, sin letra pequeña, sin complicaciones.'
  }];
  return <section className="py-12 md:py-16 relative" style={{
    background: '#EFE7D8'
  }} data-id="element-32">
      <div className="gold-divider absolute top-0 inset-x-0" data-id="element-33" />
      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-34">
        <div className="text-center mb-8" data-id="element-35">
          <h2 className="text-2xl md:text-3xl font-serif font-bold mb-2" style={{
          color: '#1C1C1C'
        }} data-id="element-36">
            ¿Tienes Preguntas?
          </h2>
          <div className="mx-auto w-20 gold-divider" data-id="element-37" />
        </div>
        <div className="space-y-2" data-id="element-38">
          {faqs.map((faq, i) => <div key={i} className="rounded-xl overflow-hidden" style={{
          background: '#F6F1E7',
          border: '1px solid rgba(200,169,106,0.25)'
        }} data-id="element-39">
              <button className="w-full flex items-center justify-between p-4 text-left" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-40">
                <span className="font-bold text-sm pr-3" style={{
              color: '#1C1C1C'
            }} data-id="element-41">
                  {faq.q}
                </span>
                <ChevronDown className="w-4 h-4 flex-shrink-0 transition-transform duration-300" style={{
              color: '#C8A96A',
              transform: openIndex === i ? 'rotate(180deg)' : 'rotate(0deg)'
            }} data-id="element-42" />
              </button>
              {openIndex === i && <div className="px-4 pb-4" data-id="element-43">
                  <div className="pt-2" style={{
              borderTop: '1px solid rgba(200,169,106,0.2)'
            }} data-id="element-44">
                    <p className="text-sm leading-relaxed pt-3" style={{
                color: '#3A3A3A'
              }} data-id="element-45">
                      {faq.a}
                    </p>
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}